export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const TIMEOUT = 50000;

export const DISABLE_PAYMENT = process.env.REACT_APP_DISABLE_PAYMENT;
export const DOMAIN_NAME = process.env.REACT_APP_TITLE;
export const YOOKASSA_LINK = process.env.REACT_APP_YOOKASSA_LINK;
